// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "pc/js/" + ({"727":"lottery","757":"game","917":"agreement","942":"article"}[chunkId] || chunkId) + "." + {"6":"3571be31","345":"d0af3df8","617":"d969f4be","727":"26662d0e","757":"6633ac24","786":"b571b755","824":"b48c27af","858":"fafd87cb","871":"0a69b593","917":"9b471226","942":"ea20faab"}[chunkId] + ".js";
};